<div class="flex w-full bg-white rounded-xl border gap-6 p-6 flex-col lg:flex-row">
  <!-- Personal information form -->
  <div class="flex bg-white flex-col gap-6 w-full lg:w-1/2">
    <form nz-form nzLayout="vertical" [formGroup]="personalInfoFormGroup" class="w-full">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'First name is required.'">
          <input nz-input nzSize="large" formControlName="firstname" placeholder="Provide firstname" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Last name is required.'">
          <input nz-input nzSize="large" formControlName="lastname" placeholder="Provide lastname" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control [nzErrorTip]="emailErrorTpl">
          <input nz-input nzSize="large" type="email" formControlName="email" placeholder="Provide email" />
          <ng-template #emailErrorTpl let-control>
            @if (control.errors?.['required']) {
              Email is required.
            } @else if (control.errors?.['email']) {
              Please enter a valid email address.
            }
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control [nzErrorTip]="phoneErrorTpl">
          <input nz-input nzSize="large" formControlName="phoneNumber" placeholder="Provide phone number" />
          <ng-template #phoneErrorTpl let-control>
            @if (control.errors?.['required']) {
              Phone number is required.
            } @else if (control.errors?.['pattern']) {
              Enter a valid 10-digit phone number.
            }
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control [nzErrorTip]="ninErrorTpl">
          <input
            nz-input nzSize="large"
            libZimbabweNationalIdFormatter
            formControlName="identificationNumber"
            placeholder="National ID eg: 08-123456D53"
          />
          <ng-template #ninErrorTpl let-control>
            @if (control.errors?.['required']) {
              National ID is required.
            } @else if (control.errors?.['invalidNationalId']) {
              Enter a valid National ID (e.g. 08-123456D53).
            }
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </form>

    <p class="leading-normal text-xs">
      By providing your info, you agree to the
      <a class="cursor-pointer underline" target="_blank" rel="noopener noreferrer" href="">terms of service</a>
      and
      <a class="cursor-pointer underline" target="_blank" rel="noopener noreferrer" href="">Privacy policy</a>
    </p>
  </div>

  <!-- Sign-in panel -->
  <div class="flex w-full flex-col items-center gap-6 lg:w-1/2 lg:border-l px-6 lg:border-l-gray-200">
    <h3 class="text-lg font-light">Already have an account?</h3>
    <div class="flex flex-col items-center gap-4 w-full">
      @if (authInfo.signInUrl) {
        <a
          target="_self"
          [href]="authInfo.signInUrl"
          class="flex items-center justify-center w-full py-2 px-4 text-sm font-semibold rounded-full border border-gray-300 hover:bg-gray-200"
        >
          Sign in
        </a>
      }
      @if (authInfo.googleSignUrl) {
        - or -
        <button
          type="button"
          class="flex items-center cursor-pointer w-full justify-center py-2 px-4 text-sm font-semibold rounded-full border border-gray-300 hover:bg-gray-200"
          (click)="loginWithGoogle()"
        >
          <img src="/images/googleicon.webp" alt="Google" class="w-5 h-5 mr-2" />
          Login with Google
        </button>
      }
    </div>

    @if (authInfo.signUpUrl) {
      <p>
        Don't have account?
        <a target="_self" class="cursor-pointer underline text-blue-600 text-sm" [href]="authInfo.signUpUrl">Sign up here</a>
      </p>
    }
  </div>
</div>
